/* eslint-disable react/no-multi-comp */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { TableCell, Grid } from '@material-ui/core';
import { Table, Filtro } from '../../components';
import * as selectorsPolos from '../../store/polo/reducer';
import * as actionsPolos from '../../store/polo/actions';
import Formulario from './Formulario';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
}));

const Polos = ({ polos, loadPolos, deletePolo }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  
  const classes = useStyles();
  
  const renderRows = d => {
    return (
      <>
        <TableCell>{d.codigo}</TableCell>
        <TableCell>{d.nome}</TableCell>
        <TableCell>{d.gerenciaCodigo}</TableCell>
      </>
    )
  }

  useEffect(() => {
    loadPolos()
  }, [loadPolos]);

  const onEdit = id => {
    setOpen(true);
    setId(id);
  }

  const onDelete = id => deletePolo(id);
  const onAdd = () => {
    setOpen(true);
    setId(null);
  }

  const onClose = () => {
    setOpen(false);
    setId(null);
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Filtro 
          onFilter={loadPolos}
          useCodigo
          useMalha
          useGerencia
        />
      </Grid>
      <Grid item xs={12} className={classes.root}>
        <Table 
          rows={polos}
          titles={['Código', 'Nome', 'Gerência']}
          headerTitle="Polos"
          renderRows={renderRows}
          hasRowActions
          onEdit={onEdit}
          onDelete={onDelete}
          onAdd={onAdd}
          showDelete={false}
        />
        <Formulario
          id={id}
          open={open}
          onClose={onClose}
          polos={polos}
        />
      </Grid>
    </Grid>
  );
};

Polos.propTypes = {
  deletePolo: PropTypes.func.isRequired,
  loadPolos: PropTypes.func.isRequired,
  polos: PropTypes.array,
};

const mapStateToProps = state => ({
  polos: selectorsPolos.getPolos(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsPolos
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Polos));